import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';
import {useTheme} from '@mui/material/styles';

const SelectEstadoReprogramar = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    defaultProps,
    isMulti
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const options = [
        {
            value: 'SITUACION CLIMATICA',
            label: 'SITUACION CLIMATICA'
        },
        {
            value: 'PENDIENTE DE EQUIPO',
            label: 'PENDIENTE DE EQUIPO',
        },
        {
            value: 'INSTALACION CANCELADA',
            label: 'INSTALACION CANCELADA'
        },
        {
            value: 'PENDIENTE POR MATERIALES/SOPORTE',
            label: 'PENDIENTE POR MATERIALES/SOPORTE',
        },
        {
            value: 'NO SE ENCONTRO EL DOMICILIO',
            label: 'NO SE ENCONTRO EL DOMICILIO'
        },
        {
            value: 'CLIENTE AUSENTE',
            label: 'CLIENTE AUSENTE',
        },
        {
            value: 'CORTE DE RUTA',
            label: 'CORTE DE RUTA',
        },
        {
            value: 'POR FALLA DE VEHICULO',
            label: 'POR FALLA DE VEHICULO',
        },
        {
            value: 'ACCIDENTE DEL PERSONAL TECNICO',
            label: 'ACCIDENTE DEL PERSONAL TECNICO',
        },
        {
            value: 'POR AUSENCIA DEL PERSONAL TECNICO',
            label: 'POR AUSENCIA DEL PERSONAL TECNICO',
        },
        {
            value: 'NODO CAIDO',
            label: 'NODO CAIDO',
        },
        {
            value: 'POR CORTE DE ENERGIA ZONAL',
            label: 'POR CORTE DE ENERGIA ZONAL',
        },
        {
            value: 'POR CORTE DE ENERGIA EN EL DOMICILIO',
            label: 'POR CORTE DE ENERGIA EN EL DOMICILIO',
        },
        {
            value: 'POR PRIORIDAD TAREAS',
            label: 'POR PRIORIDAD TAREAS',
        },
        {
            value: 'POR FIN DE TURNO - TECNICO',
            label: 'POR FIN DE TURNO - TECNICO',
        },
        {
            value: 'POR FECHA ADELANTADA',
            label: 'POR FECHA ADELANTADA',
        },
        {
            value: 'POR RETIRO PARCIAL - EQUIPO AUSENTE',
            label: 'POR RETIRO PARCIAL - EQUIPO AUSENTE',
        },
        {
            value: 'POR EQUIPO AUSENTE',
            label: 'POR EQUIPO AUSENTE',
        },
        {
            value: 'POR TRABAJO INTERNO FO',
            label: 'POR TRABAJO INTERNO FO',
        },
    ];

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>{
                const item = options.find(it=>it.value === va);
                if(item){
                    return {
                        value:item.value,
                        label:item.label
                    };
                }
                return null
            }))
        }else{
            setSelectedValue(null)
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected 
                ? (isDarkMode ? '#90caf9' : '#fff')
                : (isDarkMode ? '#e0e0e0' : '#000'),
            background: state.isSelected 
                ? (isDarkMode ? '#1a3a5c' : '#0364ff')
                : (isDarkMode ? '#2d3a52' : '#fff'),
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: isDarkMode ? '#e0e0e0' : '#e0e0e0',
            },
        }),
        control: (styles) => ({
            ...styles,
            borderRadius: 7,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
            backgroundColor: isDarkMode ? '#2d3a52' : '#fff',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        input: (provided) => ({
            ...provided,
            color: isDarkMode ? '#e0e0e0' : '#000',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: isDarkMode ? '#b0bec5' : 'gray',
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: isDarkMode ? '#1a3a5c' : '#0364ff',
                borderRadius: 5,
                border: isDarkMode ? '1px solid #fff' : 'none',
                border: isDarkMode ? '1px solid #fff' : 'none'
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: isDarkMode ? '#90caf9' : '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: isDarkMode ? '#90caf9' : '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: isDarkMode ? '#3d4a62' : '#02378c',
                color: '#e0e0e0',
            },
        }),
    }), [isDarkMode])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isMulti={isMulti}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectEstadoReprogramar.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectEstadoReprogramar;